import React from 'react'

function About() {
  return (
    <div className='about-container'>
      <h1 className="page-title">Blackbird 66</h1>
      <p>Blackbird 66 is the motorsport-focused special projects studio of professional racer JR
Hildebrand. The 12-time Indy 500 competitor has operated at the intersection of
competition, innovation, and design while racing at the top tier of global motorsport for
15+ years. Over that time he’s developed a keen ability to quickly form highly-skilled
small teams to tackle a wide variety of endeavors; Blackbird 66 is the place where he
brings these fields and a collection of exceptional cross-industry collaborators together
under one umbrella.</p>

      <p>From self-generated design projects like the Blackbird 66 Mk.1 to strategic guidance
and operation of bespoke race programs (coming in 2026), Blackbird 66 is a mission-
driven organization with one simple goal: inspire and actively create the most vibrant
and awesome future of motorsport possible. If you have the same ambition and desire, 
we’re happy you’re here, and urge you to reach out. We’re all in this together, and it’s up
to us!</p>
      <p style={{ fontWeight: 'bold', fontSize: '1.2em' }}><i>The Blackbird 66 Mk.1</i></p>

      <p>The Mk.1 project is a collaboration between JR and concept designer Patrick Faulwetter
with influence and support from numerous members of the motorsport community who
have added to and helped guide the process.</p>
    </div>
  )
}

export default About
